import { render, staticRenderFns } from "./SystemFixBidderFormView.vue?vue&type=template&id=838c409a&scoped=true&"
import script from "./SystemFixBidderFormView.vue?vue&type=script&lang=js&"
export * from "./SystemFixBidderFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838c409a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect,VTextField})
